var Curriculog = Curriculog || {};

Curriculog.AdvancedFilter = (function ($, _, Backbone, AdvancedFilter) {

	AdvancedFilter = Curriculog.CurriculogView.extend({

		el: function () {
			return $('#advanced-filter');
		},

		events: {
			'click .advanced-search': 'toggle',
			'click button[name="generate-report"]': 'execute',
			'click button[name="cancel"]': 'reset',
			'click button[name="clear-dates"]': 'clearDates',
		},

		initialize: function(options) {
			this.$filter = $('#curriculog-list-column-results .report-filter');
			this.params = options.params;
			this.defaultQueries = options.defaultQueries;
			this.render();

			// init subviews
			this.entityFilter = new Curriculog.EntityFilter({
				id: 'report-9-entity-types',
				collection: app.relationships,
				params: this.params,
				filterParam: 'entity',
				firstOption: 'All Entities',
				noAvailableOptionsMessage: 'No Eligible Entities Available',
			});
			this.apFilter = new Curriculog.ApFilter({
				id: 'report-9-process-id',
				collection: app.approvalProcesses,
				params: this.params,
				filterParam: {ap: 'ap', type: 'type'},
				firstOption: 'All Processes',
				noAvailableOptionsMessage: 'No Processes Available',
			});
			this.userRolesFilter = new Curriculog.UserRolesFilter({
				id: 'report-9-role-id',
				collection: app.userRolesForFilter,
				params: this.params,
				filterParam: 'role',
				firstOption: 'All My Roles',
				noAvailableOptionsMessage: 'No User Roles Available',
			});
			this.currentStepFilter = new Curriculog.CurrentStepFilter({
				id: 'report-9-step-name',
				collection: app.currentSteps,
				params: this.params,
				filterParam: 'currentStep',
				firstOption: 'All Current Steps',
				noAvailableOptionsMessage: 'No Current Steps Available',
			});
			this.includeEntityChildrenFilter = new Curriculog.IncludeEntityChildrenFilter({params: this.params});
			this.dateTypeFilter = new Curriculog.DateTypeFilter({params: this.params});
			this.statusFilter = new Curriculog.StatusFilter({
				params: this.params,
				defaultQueries: this.defaultQueries});
			this.flagFilter = new Curriculog.FlagFilter({
				params: this.params,
				defaultQueries: this.defaultQueries});
			this.emptyStepFilter = new Curriculog.EmptyStepFilter({
				params: this.params,
				defaultQueries: this.defaultQueries});
			this.deadlineFilter = new Curriculog.DeadlineFilter({
				params: this.params,
				defaultQueries: this.defaultQueries});
			this.decisionFilter = new Curriculog.DecisionFilter({params: this.params});
			this.keywordFilter = new Curriculog.KeywordFilter({params: this.params});

			// set listeners
			this.listenTo(Backbone, 'tabs:change', this.close);
			this.listenTo(Backbone, 'keyword:press', this.execute);

			// if loading a session involving advanced filter, open it
			if (this.params.domParams.get('filterType') === 'advanced') {
				this.toggle();
			}

			// Initialize the select2 plugin for all selects
			this.$el.find('select').selectWoo({
				theme: 'curriculog'
			});
		},

		render: function() {
      if (this.params.cui_enabled) {
        // Evaluate the level and render the appropriate advanced filter template
  			var $filter = this.$el.find('.report-filter');
  			var level = this.params.domParams.get('level');
  			var template = 'advancedFilter' + level.charAt(0).toUpperCase() + level.substring(1);

  			$filter.contents().remove();
  			$filter.append(nunjucks.render('ProposalList/' + template + '-cui.html'));
      } else {
        // Evaluate the level and render the appropriate advanced filter template
  			var $filter = this.$el.find('.report-search-fields');
  			var level = this.params.domParams.get('level');
  			var template = 'advancedFilter' + level.charAt(0).toUpperCase() + level.substring(1);

  			$filter.contents().remove();
  			$filter.append(nunjucks.render('ProposalList/' + template + '.html'));
      }
		},

		execute: function(event) {
			if (event !== undefined) {
				event.preventDefault();
			}

			var result = this.dateTypeFilter.validate();

			if (! result.valid) {
				this.setFilterHeight();
				Backbone.trigger('list:stretch');
				return;
			}

			// base query
			this.getBase();

			this.apFilter.set();
			this.currentStepFilter.set();
			this.dateTypeFilter.set();
			this.deadlineFilter.set();
			this.entityFilter.set();
			this.emptyStepFilter.set();
			this.flagFilter.set();
			this.includeEntityChildrenFilter.set();
			this.keywordFilter.set();
			this.statusFilter.set();
			this.decisionFilter.set();

			if (this.params.domParams.get('level') !== 'admin') {
				this.userRolesFilter.set();
			}

			this.params.domParams.set('filterType', 'advanced');

			// Broadcast get event
			Backbone.trigger('page:reset');
			Backbone.trigger('filter:submit');
		},

		toggle: function(event) {
			// if clicking into filter, click event is present
			// if coming from session, click event is undefined
			$.validity.clear();
			if (event !== undefined) {
				event.preventDefault();
				event.stopPropagation();
			}

			var visibility = this.visibility();
			var that = this;

			if (visibility.isOpen) {
				this.reset();
			}

			if (visibility.isClosed) {
				objDom.addCustomMask('#curriculog-list-column-results-sorting', 'Loading', '75');
				this.$filter.slideDown(function () {
					that.getDatasets();
					that.dateTypeFilter.get();
					that.deadlineFilter.get();
					that.emptyStepFilter.get();
					that.flagFilter.get();
					that.includeEntityChildrenFilter.get();
					that.keywordFilter.get();
					that.statusFilter.get();
					that.decisionFilter.get();

					// set mutually exclusive filters
					that.emptyStepFilter.evaluate();
					that.decisionFilter.evaluate();

					that.setFilterHeight(that.$filter);
					Backbone.trigger('advancedFilter:toggleOpen');
					Backbone.trigger('list:stretch');
				});
			}
		},

		getDatasets: function() {
			// Store all the filters that need to get a dataset in an object
			// to be iterated on
			var config = {
			        ap: {
			            self: this.apFilter,
			            rendered: false,
			            dependencies: ['currentStep'],
			        },
			        entity: {
			            self: this.entityFilter,
			            rendered: false,
			        },
			        currentStep: {
			            self: this.currentStepFilter,
			            rendered: false,
			            disabled: this.params.domParams.get('tab') === 'completed' ? true : false,
			        },
			    },
			    currentFilter = '';

			// Add/remove any filters that should[n't] be on the user side
			if (this.params.domParams.get('level') !== 'admin') {
				config.userRole = {
					self: this.userRolesFilter,
					rendered: false,
				};
			}



			for (currentFilter in config) {
				// If the current filter is dependent on another dataset,
				// make sure to load the dependency dataset first before
				// loading the dependent dataset (and rendering the dropdowns)
				if (config[currentFilter].dependencies) {
					var that = this;

					// Run through all dependencies and set their deferred with some data
					// in order to be able to call the dependent ajax call
					_.each(config[currentFilter].dependencies, function (dependency) {
						// If the dependency is supposed to be disabled, call the
						// disable dropdown method on the dependency and just call for the
						// full dataset of the currentFilter
						if (config[dependency].disabled) {
							if (!config[dependency].rendered) {
								that.disableDropdown(config, dependency);
							}

							// Set the queued attribute to true for the dependency so
							// the deferred doesn't get replaced in the lower 'else if'
							config[currentFilter].queued = true;
							config[currentFilter].xhr = config[currentFilter].self.get();

							return;
						}

						// Set the queued attribute to true for the dependency so
						// the deferred doesn't get replaced in the lower 'else if'
						config[dependency].queued = true;

						// Set the dependency deferred with some options to be passed to
						// the deferred 'always' call to be able to call the dependent ajax call
						// at that point in time
						config[dependency].xhr = config[dependency].self.get({
							that: that,
							currentFilter: currentFilter,
						});

						// Set up the deferred 'always' so that we can call the dependent ajax call
						// after the dependency ajax call has been run and the dataset has been queued
						config[dependency].xhr.always(function (options) {
							// Add a robot call when the dependency dropdown has rendered
							Curriculog.Actions.log(options.currentFilter + '-filter-rendered-dependency');

							config[options.currentFilter].self.get({
								that: options.that,
								currentFilter: options.currentFilter,
							}).always(function (options) {
								// Add a robot call when the dependent has rendered
								Curriculog.Actions.log(options.currentFilter + '-filter-rendered-dependent');
							});
						});
					});
				} else if (config[currentFilter].disabled) {
					// If we want to disable the dropdown and not show any options
					this.disableDropdown(config, currentFilter);
				} else if (!config[currentFilter].queued) {
					// If a filter isn't a dependent or a dependency, set the ajax
					// deferred up regulary
					config[currentFilter].queued = true;
					config[currentFilter].xhr = config[currentFilter].self.get({
						that: this,
						currentFilter: currentFilter,
					}).always(function (options) {
						// Add a robot call when regular dropdowns have rendered
						Curriculog.Actions.log(options.currentFilter + '-filter-rendered');
					});
				}
			}

			// Check to see if all filter rendered properties are true, if so,
			// do not call for any data and instead just remove mask
			if (_.every(Object.keys(config), function (key) { return config[key].rendered; })) {
				objDom.removeMask('#curriculog-list-column-results-sorting');
			} else {
				// Only call for data on dropdowns that have not rendered fully yet
				$.when(_.map(Object.keys(config), function (key) {
					if (config[key].xhr) {
						return config[key].xhr;
					}
				})).then(function() {
					// Add a robot call when all dataset ajax deferreds have been queued up
					Curriculog.Actions.log('all-advanced-filter-dataset-deferreds-queued');

					objDom.removeMask('#curriculog-list-column-results-sorting');
				});
			}
		},

		disableDropdown: function (config, filter) {
			config[filter].self.get({
				disabled: true
			});

			// Because we are creating a disabled empty dropdown,
			// go ahead and render the dropdown and set the rendered
			// property to true
			config[filter].rendered = true;

			// Add a robot call when disabled dropdowns have rendered
			Curriculog.Actions.log(filter + '-filter-rendered-disabled');
		},

		setFilterHeight: function() {
      if (!this.params.cui_enabled) {
        var $results = $('#curriculog-list-column-results');
        var $dashboard = $('#curriculog-dashboard-column');
        var $summary = $('#curriculog-summary-column');
        var visibility = this.visibility();

        // Build an array of the heights of all child elements in $results.
        // Be sure to reset the filter's height first or it will calculate incorrectly
        this.$filter.css('height', 'auto');
        var childHeights = $results.children().toArray().reduce(function(x, y) {
          return x + $(y).height();
        }, 0);

        // If there is not enough room for the filter to open, then add the height
        // of the filter to the height of all columns.
        if ((childHeights + this.$filter.height()) > $results.height() && visibility.isClosed) {
          var height = $results.css('height', 'auto').height() + this.$filter.height();
          $dashboard.height(height);
          $summary.height(height);
          $results.height(height);
        }

        // This is a fix for the jQuery slideToggle snap-back issue
        // http://stackoverflow.com/questions/5943994/jquery-slidedown-snap-back-issue
        this.$filter.height(this.$filter.css('height', 'auto').height());
      }
		},

		getBase: function() {
			var defaultQuery = this.defaultQueries[this.params.domParams.get('tab')].getDefaultParams();
			this.params.queryParams.set(defaultQuery);

		},

		clearForm: function() {
			// reset the form input values so we don't carry over any old search
			// params with the change of filter type
			this.getDatasets();
			this.dateTypeFilter.get();
			this.deadlineFilter.get();
			this.emptyStepFilter.get();
			this.flagFilter.get();
			this.includeEntityChildrenFilter.get();
			this.keywordFilter.get();
			this.statusFilter.get();
			this.decisionFilter.get();
			$.validity.clear();
			this.params.domParams.set('filterType', 'tab');
		},

		reset: function() {
			// toggleAdvancedFilter
			this.close();

			// reset the model and paging and
			this.getBase();
			this.params.pagingParams.reset();
			this.params.paramsLoadedFromSession = false;

			// return the current tab's search results
			Backbone.trigger('filter:submit');
		},

		close: function() {
			// Rather than call toggle, which can react negatively if user fast clicked
			// or double clicked the tab, just slide the item shut, which is always the
			// desired reaction
			var visibility = this.visibility(),
				that = this;

			if (visibility.isOpen) {
				this.$filter.slideUp(function () {
					that.clearForm();
					Backbone.trigger('advancedFilter:toggleClosed');
					return;
				});
			}
		},

		visibility: function() {
			var isClosed = this.$filter.css('display') === 'none';
			var isOpen = ! isClosed;
			return {
				isClosed: isClosed,
				isOpen: isOpen
			};
		},

		clearDates: function () {
			Backbone.trigger('dateInputs:clear');
		}
	});

	return AdvancedFilter;

})($, _, Backbone, Curriculog.AdvancedFilter || {});
